
import React, { useState } from "react";
const { types } = require('sharetribe-flex-sdk');

import { AvatarLarge, H4, H5, Heading, IconClose, InlineTextButton, Map, Modal, NamedLink, Ratings, ResponsiveImage, Reviews } from "../../../components";
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import countryList from 'country-list';
import { truncate } from "lodash";
import { manageDisableScrolling } from "../../../ducks/ui.duck";
import IconCard from "../../../components/SavedCardDetails/IconCard/IconCard";
import { pathByRouteName } from "../../../util/routes";
// import { FacebookShareButton } from "react-share";
import css from './Profile.module.css';
import classNames from "classnames";

const { LatLng } = types;





// Approximated collapsed size so that there are ~three lines of text
// in the desktop layout in the author section of the ListingPage.
const BIO_COLLAPSED_LENGTH = 200;

const truncated = s => {
    return truncate(s, {
        length: BIO_COLLAPSED_LENGTH,

        // Allow truncated text end only in specific characters. This will
        // make the truncated text shorter than the length if the original
        // text has to be shortened and the substring ends in a separator.
        //
        // This ensures that the final text doesn't get cut in the middle
        // of a word.
        separator: /\s|,|\.|:|;/,
        omission: '…',
    });
};

const ExpandableBio = props => {
    const [expand, setExpand] = useState(false);
    const { className, bio } = props;
    const truncatedBio = truncated(bio);

    const handleShowMoreClick = () => {
        setExpand(true);
    };
    const showMore = (
        <InlineTextButton rootClassName={css.showMore} onClick={handleShowMoreClick}>
            <FormattedMessage id="StoreProfilePage.Profile.showFullBioLink" />
        </InlineTextButton>
    );
    return (
        <span className={className}>
            {expand ? bio : truncatedBio}
            {bio !== truncatedBio && !expand ? showMore : null}
        </span>
    );
};


const ReviewsSectionMaybe = (props) => {
    const { reviews, queryReviewsError, onClose } = props;

    return (
        <div className={css.reviewsSection}>
            <div className={css.reviewsHeader}>
                <Heading as="h4" rootClassName={css.sectionHeadingWithExtraMargin}>
                    <FormattedMessage id="StoreProfilePage.Profile.reviewsTitle" values={{ count: reviews.length }} />
                </Heading>
                <button onClick={onClose} className={css.reviewClose} type="button"><IconClose /></button>
            </div>
            {queryReviewsError ? (
                <H4 className={css.errorText}>
                    <FormattedMessage id="StoreProfilePage.Profile.reviewsError" />
                </H4>
            ) : null}
            {!reviews || !reviews.length ? <H5 style={{ textAlign: 'center', }}>No Review found!</H5> : null}
            <Reviews reviews={reviews} />
        </div>
    );
};

const FacebookShareButton = ({ url, quote }) => {
    const handleClick = () => {
        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                url
            )}&quote=${encodeURIComponent(quote)}`,
            'facebook-share-dialog',

        );
    };

    return (<button onClick={handleClick} style={{ border: "none", cursor: "pointer" }}>
        <svg width="50px" height="50px" viewBox="0 0 1 1" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#1877F2" d="M0.938 0.5a0.438 0.438 0 0 0 -0.438 -0.438 0.438 0.438 0 0 0 -0.068 0.87v-0.306H0.321V0.5h0.111V0.404c0 -0.11 0.065 -0.17 0.165 -0.17 0.048 0 0.098 0.009 0.098 0.009v0.108h-0.055c-0.054 0 -0.071 0.034 -0.071 0.068V0.5h0.121l-0.019 0.126H0.568v0.306A0.438 0.438 0 0 0 0.938 0.5" /><path fill="#ffffff" d="M0.67 0.626 0.69 0.5H0.568V0.418c0 -0.035 0.017 -0.068 0.071 -0.068h0.055V0.242s-0.05 -0.009 -0.098 -0.009c-0.1 0 -0.165 0.061 -0.165 0.17V0.5H0.321v0.126h0.111v0.306a0.438 0.438 0 0 0 0.137 0v-0.306z" /></svg>
    </button>);
};

const WhatsAppShareButton = ({ url, quote }) => {
    const handleClick = () => {
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(quote)}%20${encodeURIComponent(url)}`, '_blank');
    };

    return (
        <button onClick={handleClick} style={{ border: "none", cursor: "pointer" }}>
            <svg width="50px" height="50px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M16 31C23.732 31 30 24.732 30 17C30 9.26801 23.732 3 16 3C8.26801 3 2 9.26801 2 17C2 19.5109 2.661 21.8674 3.81847 23.905L2 31L9.31486 29.3038C11.3014 30.3854 13.5789 31 16 31ZM16 28.8462C22.5425 28.8462 27.8462 23.5425 27.8462 17C27.8462 10.4576 22.5425 5.15385 16 5.15385C9.45755 5.15385 4.15385 10.4576 4.15385 17C4.15385 19.5261 4.9445 21.8675 6.29184 23.7902L5.23077 27.7692L9.27993 26.7569C11.1894 28.0746 13.5046 28.8462 16 28.8462Z" fill="#BFC8D0" />
                <path d="M28 16C28 22.6274 22.6274 28 16 28C13.4722 28 11.1269 27.2184 9.19266 25.8837L5.09091 26.9091L6.16576 22.8784C4.80092 20.9307 4 18.5589 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" fill="url(#paint0_linear_87_7264)" />
                <path fillRule="evenodd" clipRule="evenodd" d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 18.5109 2.661 20.8674 3.81847 22.905L2 30L9.31486 28.3038C11.3014 29.3854 13.5789 30 16 30ZM16 27.8462C22.5425 27.8462 27.8462 22.5425 27.8462 16C27.8462 9.45755 22.5425 4.15385 16 4.15385C9.45755 4.15385 4.15385 9.45755 4.15385 16C4.15385 18.5261 4.9445 20.8675 6.29184 22.7902L5.23077 26.7692L9.27993 25.7569C11.1894 27.0746 13.5046 27.8462 16 27.8462Z" fill="white" />
                <path d="M12.5 9.49989C12.1672 8.83131 11.6565 8.8905 11.1407 8.8905C10.2188 8.8905 8.78125 9.99478 8.78125 12.05C8.78125 13.7343 9.52345 15.578 12.0244 18.3361C14.438 20.9979 17.6094 22.3748 20.2422 22.3279C22.875 22.2811 23.4167 20.0154 23.4167 19.2503C23.4167 18.9112 23.2062 18.742 23.0613 18.696C22.1641 18.2654 20.5093 17.4631 20.1328 17.3124C19.7563 17.1617 19.5597 17.3656 19.4375 17.4765C19.0961 17.8018 18.4193 18.7608 18.1875 18.9765C17.9558 19.1922 17.6103 19.083 17.4665 19.0015C16.9374 18.7892 15.5029 18.1511 14.3595 17.0426C12.9453 15.6718 12.8623 15.2001 12.5959 14.7803C12.3828 14.4444 12.5392 14.2384 12.6172 14.1483C12.9219 13.7968 13.3426 13.254 13.5313 12.9843C13.7199 12.7145 13.5702 12.305 13.4803 12.05C13.0938 10.953 12.7663 10.0347 12.5 9.49989Z" fill="white" />
                <defs>
                    <linearGradient id="paint0_linear_87_7264" x1="26.5" y1="7" x2="4" y2="28" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#5BD066" />
                        <stop offset="1" stopColor="#27B43E" />
                    </linearGradient>
                </defs>
            </svg>
        </button>
    );
};

const InstagramShareButton = ({ url }) => {
    const handleClick = () => {
        window.open(`https://www.instagram.com/${encodeURIComponent(url)}`, '_blank');
    };

    return (
        <button onClick={handleClick} style={{ border: "none", cursor: "pointer" }}>
            <svg width="50px" height="50px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="24" r="20" fill="#d62976" />
                <path d="M24 14.1622C27.2041 14.1622 27.5837 14.1744 28.849 14.2321C30.019 14.2855 30.6544 14.481 31.0773 14.6453C31.6374 14.863 32.0371 15.123 32.457 15.5429C32.877 15.9629 33.137 16.3626 33.3547 16.9227C33.519 17.3456 33.7145 17.981 33.7679 19.1509C33.8256 20.4163 33.8378 20.7958 33.8378 23.9999C33.8378 27.2041 33.8256 27.5836 33.7679 28.849C33.7145 30.019 33.519 30.6543 33.3547 31.0772C33.137 31.6373 32.877 32.0371 32.4571 32.457C32.0371 32.8769 31.6374 33.1369 31.0773 33.3546C30.6544 33.519 30.019 33.7144 28.849 33.7678C27.5839 33.8255 27.2044 33.8378 24 33.8378C20.7956 33.8378 20.4162 33.8255 19.151 33.7678C17.981 33.7144 17.3456 33.519 16.9227 33.3546C16.3626 33.1369 15.9629 32.8769 15.543 32.457C15.1231 32.0371 14.863 31.6373 14.6453 31.0772C14.481 30.6543 14.2855 30.019 14.2321 28.849C14.1744 27.5836 14.1622 27.2041 14.1622 23.9999C14.1622 20.7958 14.1744 20.4163 14.2321 19.1509C14.2855 17.981 14.481 17.3456 14.6453 16.9227C14.863 16.3626 15.123 15.9629 15.543 15.543C15.9629 15.123 16.3626 14.863 16.9227 14.6453C17.3456 14.481 17.981 14.2855 19.151 14.2321C20.4163 14.1744 20.7959 14.1622 24 14.1622ZM24 12C20.741 12 20.3323 12.0138 19.0524 12.0722C17.7752 12.1305 16.9028 12.3333 16.1395 12.63C15.3504 12.9366 14.6812 13.3469 14.0141 14.0141C13.3469 14.6812 12.9366 15.3504 12.63 16.1395C12.3333 16.9028 12.1305 17.7751 12.0722 19.0524C12.0138 20.3323 12 20.741 12 23.9999C12 27.259 12.0138 27.6676 12.0722 28.9475C12.1305 30.2248 12.3333 31.0971 12.63 31.8604C12.9366 32.6495 13.3469 33.3187 14.0141 33.9859C14.6812 34.653 15.3504 35.0633 16.1395 35.3699C16.9028 35.6666 17.7752 35.8694 19.0524 35.9277C20.3323 35.9861 20.741 35.9999 24 35.9999C27.259 35.9999 27.6677 35.9861 28.9476 35.9277C30.2248 35.8694 31.0972 35.6666 31.8605 35.3699C32.6496 35.0633 33.3188 34.653 33.9859 33.9859C34.653 33.3187 35.0634 32.6495 35.37 31.8604C35.6667 31.0971 35.8695 30.2248 35.9278 28.9475C35.9862 27.6676 36 27.259 36 23.9999C36 20.741 35.9862 20.3323 35.9278 19.0524C35.8695 17.7751 35.6667 16.9028 35.37 16.1395C35.0634 15.3504 34.653 14.6812 33.9859 14.0141C33.3188 13.3469 32.6496 12.9366 31.8605 12.63C31.0972 12.3333 30.2248 12.1305 28.9476 12.0722C27.6677 12.0138 27.259 12 24 12Z" fill="white" />
                <path d="M24.0059 17.8433C20.6026 17.8433 17.8438 20.6021 17.8438 24.0054C17.8438 27.4087 20.6026 30.1675 24.0059 30.1675C27.4092 30.1675 30.1681 27.4087 30.1681 24.0054C30.1681 20.6021 27.4092 17.8433 24.0059 17.8433ZM24.0059 28.0054C21.7968 28.0054 20.0059 26.2145 20.0059 24.0054C20.0059 21.7963 21.7968 20.0054 24.0059 20.0054C26.2151 20.0054 28.0059 21.7963 28.0059 24.0054C28.0059 26.2145 26.2151 28.0054 24.0059 28.0054Z" fill="white" />
                <path d="M31.8507 17.5963C31.8507 18.3915 31.206 19.0363 30.4107 19.0363C29.6154 19.0363 28.9707 18.3915 28.9707 17.5963C28.9707 16.801 29.6154 16.1562 30.4107 16.1562C31.206 16.1562 31.8507 16.801 31.8507 17.5963Z" fill="white" />
            </svg>
        </button>
    );
};

const EmailShare = ({ url }) => {
    const handleEmailShare = () => {
        const subject = 'Check out this awesome website!';
        const body = `Hey! I found this interesting website: ${url}. Thought you might like it!`;

        // Construct the mailto link
        const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        // Open the default email client with the mailto link
        window.location.href = mailtoUrl;
    }

    return (
        <div>
            <button onClick={handleEmailShare} style={{ border: "none", cursor: "pointer" }}>
                <svg width="50px" height="50px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z" fill="white" />
                    <path d="M22.0515 8.52295L16.0644 13.1954L9.94043 8.52295V8.52421L9.94783 8.53053V15.0732L15.9954 19.8466L22.0515 15.2575V8.52295Z" fill="#EA4335" />
                    <path d="M23.6231 7.38639L22.0508 8.52292V15.2575L26.9983 11.459V9.17074C26.9983 9.17074 26.3978 5.90258 23.6231 7.38639Z" fill="#FBBC05" />
                    <path d="M22.0508 15.2575V23.9924H25.8428C25.8428 23.9924 26.9219 23.8813 26.9995 22.6513V11.459L22.0508 15.2575Z" fill="#34A853" />
                    <path d="M9.94811 24.0001V15.0732L9.94043 15.0669L9.94811 24.0001Z" fill="#C5221F" />
                    <path d="M9.94014 8.52404L8.37646 7.39382C5.60179 5.91001 5 9.17692 5 9.17692V11.4651L9.94014 15.0667V8.52404Z" fill="#C5221F" />
                    <path d="M9.94043 8.52441V15.0671L9.94811 15.0734V8.53073L9.94043 8.52441Z" fill="#C5221F" />
                    <path d="M5 11.4668V22.6591C5.07646 23.8904 6.15673 24.0003 6.15673 24.0003H9.94877L9.94014 15.0671L5 11.4668Z" fill="#4285F4" />
                </svg>
            </button>
        </div>
    );
};

const SocialSharesModel = ({ isOpen, onClose, location, intl }) => {
    const { pathname, search } = location;
    const rootUrl = process.env.REACT_APP_MARKETPLACE_ROOT_URL
    const shareableLink = `${rootUrl}${pathname}${search}`;
    const quote = intl.formatMessage({ id: 'StoreProfilePage.Profile.sharedLinkQuote' });
    // console.log(shareableLink, '&&& &&& => shareableLink');

    return (<Modal
        id="social-share-model"
        isOpen={isOpen}
        onClose={() => {
            onClose(false);
            console.log('Closing modal');
        }}
        onManageDisableScrolling={manageDisableScrolling}
    >
        <div className={css.socialSharesButtons}>
            <FacebookShareButton quote={quote} url={shareableLink} />
            <WhatsAppShareButton quote={quote} url={shareableLink} />
            <InstagramShareButton quote={quote} url={shareableLink} />
            <EmailShare url="www.rentanythingstore.com" />
        </div>
    </Modal>)
};


const LinkCopied = (props) => {
    const { message } = props;
    return (<div className={css.linkCopied}>
        <span>link has been copied and is ready to share.</span>
    </div>)
};


const LocationMap = (props) => {
    const [isMapOpened, setIsMapOpened] = useState(false);
    const { cityAndCountryMaybe, geolocation, address, className } = props;

    if (!cityAndCountryMaybe) return null;

    const mapProps = { address, center: geolocation };

    return (
        <div className={classNames(css.locationRoot, className)}>
            <div className={css.locationInfo} onClick={() => setIsMapOpened(!!geolocation)}>{cityAndCountryMaybe}</div>
            {isMapOpened ? <div className={css.mapBox}>
                <Map {...mapProps} useStaticMap={false} />
                <button className={css.iconClose} type="button" onClick={() => setIsMapOpened(false)}>
                    <IconClose />
                </button>
            </div> : null}
        </div>
    )
};




const ProfileCardMobile = (props) => {
    const {
        user,
        displayName,
        abbreviatedName,
        cityAndCountryMaybe,
        bio,
        rating,
        reviews,
        totalReviews,
        setShowReviews,
        // setShowSocialShare,
        totalListings,
        handleCopyLink,
        showChangeImage,
        onChangeImage,
        locationMap,
        showUpdateStoreName,
        isVerified
    } = props;

    console.log(isVerified);

    return (
      <div className={css.cardMobile}>
        <div className={css.imgContainer}>
          <ResponsiveImage
            className={css.avtar}
            image={user.profileImage}
            alt={displayName || ''}
            variants={['square-small', 'square-small2x']}
            abbreviatedName={abbreviatedName}
          />
          {showChangeImage ? (
            <div className={css.changeAvatarMoblile} onClick={onChangeImage}>
              <FormattedMessage id="ProfileSettingsForm.changeAvatar" />
            </div>
          ) : null}
        </div>
        <div className={css.storeInfoMob}>
          <div className={css.storeDisplay}>
              <span className={css.storeNameMob}>{displayName} {isVerified ? <IconCard brand="verifiedShield" /> : null}</span>
            {showUpdateStoreName ? (
              <NamedLink
                name="ProfileSettingsPage"
                to={{ search: '?focusStoreField=true' }}
                className={css.updateStoreName}
              />
            ) : null}
          </div>
          {cityAndCountryMaybe}
          <div className={css.ratingMob}>
            <Ratings className={css.ratingMob} rating={rating} reviews={reviews} />
          </div>
          {!!bio?.trim() ? (
            <ExpandableBio className={css.descriptionMob} bio={bio} />
          ) : null}
        </div>
        <div className={css.reviewsMob}>
          <button
            className={css.reviewsButtonMob}
            type="button"
            onClick={() => setShowReviews(true)}
          >
            {totalReviews > 1
              ? `${totalReviews} Reviews`
              : `${totalReviews} Review`}
          </button>
          <span> | </span>
          <a className={css.reviewsButtonMob} href="#hits">
            {totalListings > 1
              ? `${totalListings} Listings`
              : `${totalListings} Listing`}
          </a>
        </div>
        <button className={css.shareButtonMob} onClick={handleCopyLink}>
          <FormattedMessage id="StoreProfilePage.Profile.mobileCopyLink" />
        </button>
      </div>
    );
}


const Profile = (props) => {
    const intl = useIntl();
    const [showReviews, setShowReviews] = useState(false);
    const [showSocialShare, setShowSocialShare] = useState(false);
    const [copied, setIsCopied] = useState(false);
    const [isMapOpened, setIsMapOpened] = useState(false);

    const { user,
        totalReviews,
        totalListings,
        reviews: listingsReviews,
        queryReviewsError,
        history,
        location,
        storeUrl,
        isCurrentUser,
        routes,
        isVerified,
    } = props;
    const { bio, displayName:userName, publicData, abbreviatedName } = user?.attributes?.profile || {};


    const { city, country: countryCode, rating, reviews, origin, address, storeName } = publicData || {};
    const countryName = !!countryCode?.trim() ? countryList.getName(countryCode) : null;

    const displayName = !!storeName ? storeName : userName;

    const cityAndCountryMaybe = city?.trim() && countryName?.trim()
        ? <p className={css.location} onClick={() => setIsMapOpened(true)}>{city}, {countryName}</p>
        : city
            ? <p className={css.location} onClick={() => setIsMapOpened(true)}>{city}</p>
            : countryName
                ? <p className={css.location} onClick={() => setIsMapOpened(true)}>{countryName}</p>
                : null;

    const showChangeImage = isCurrentUser && !user.profileImage;

    const { lat, lng } = origin || {};
    const geolocation = lat && lng ? new LatLng(lat, lng) : null;

    const mapProps = { address, center: geolocation };
    
    const handleCopyLink = () => {
        if (window && navigator) {
            const url = storeUrl;
            navigator.clipboard.writeText(url)
                .then(() => {
                    // alert('link has been copied and is ready to share.');
                    setIsCopied(true);
                    setTimeout(() => {
                        setIsCopied(false)
                    }, 2000)

                })
                .catch((error) => {
                    console.error('Failed to copy:', error);
                    alert('something went wrong! please try again.')
                });
        };
    };

    const handleChangeImg = () => {
        const pathToProfileSettings = pathByRouteName('ProfileSettingsPage', routes);
        history.push(pathToProfileSettings)
    };
    
    const showUpdateStoreName = !storeName?.trim() && isCurrentUser;

    return (
      <div className={css.profileContainer}>
        {copied ? <LinkCopied /> : null}
        <ProfileCardMobile
          user={user}
          displayName={displayName}
          abbreviatedName={abbreviatedName}
          cityAndCountryMaybe={cityAndCountryMaybe}
          bio={bio}
          rating={rating}
          reviews={reviews}
          totalReviews={totalReviews}
          setShowReviews={setShowReviews}
          handleCopyLink={handleCopyLink}
          totalListings={totalListings}
          showChangeImage={showChangeImage}
          onChangeImage={handleChangeImg}
          showUpdateStoreName={showUpdateStoreName}
          isVerified={isVerified}
        />
        <div className={css.cardDesktop}>
          <SocialSharesModel
            isOpen={showSocialShare}
            onClose={() => setShowSocialShare(false)}
            location={location}
            intl={intl}
          />
          <div className={css.infoContainer}>
            <div className={css.userInfo}>
              {/* <AvatarLarge className={css.avtar} user={user} /> */}
              <div className={css.imgContainer}>
                <ResponsiveImage
                  className={css.avtar}
                  image={user.profileImage}
                  alt={displayName || ''}
                  variants={['square-small', 'square-small2x']}
                  abbreviatedName={abbreviatedName}
                />
                {showChangeImage ? (
                  <div className={css.changeAvatar} onClick={handleChangeImg}>
                    <FormattedMessage id="ProfileSettingsForm.changeAvatar" />
                  </div>
                ) : null}
              </div>
              <div className={css.storeInfo}>
                <div className={css.storeDisplay}>
                  <span className={css.storeName}>{displayName} {isVerified ? <IconCard brand="verifiedShield" /> : null}</span>
                  {showUpdateStoreName ? <NamedLink name="ProfileSettingsPage" to={{search:"?focusStoreField=true"}} className={css.updateStoreName} />:null}
                </div>

                {cityAndCountryMaybe}
                {!!bio?.trim() ? (
                  <ExpandableBio className={css.description} bio={bio} />
                ) : null}
              </div>
            </div>
            <div className={css.userQuality}>
              <button className={css.shareButton} onClick={handleCopyLink}>
                <FormattedMessage id="StoreProfilePage.Profile.desktopCopyLink" />
              </button>
              <div className={css.rating}>
                <Ratings className={css.rating} rating={rating} reviews={reviews} />
                <div className={css.reviews}>
                  <button
                    className={css.reviewsButton}
                    type="button"
                    onClick={() => setShowReviews(true)}
                  >
                    {totalReviews > 1
                      ? `${totalReviews} Reviews`
                      : `${totalReviews} Review`}
                  </button>
                  <span> | </span>
                  <a href="#hits">
                    {totalListings > 1
                      ? `${totalListings} Listings`
                      : `${totalListings} Listing`}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isMapOpened ? (
          <div className={css.mapBox}>
            <Map {...mapProps} useStaticMap={false} />
            <button
              className={css.iconClose}
              type="button"
              onClick={() => setIsMapOpened(false)}
            >
              <IconClose />
            </button>
          </div>
        ) : null}
        {showReviews ? (
          <ReviewsSectionMaybe
            reviews={listingsReviews}
            queryReviewsError={queryReviewsError}
            onClose={() => setShowReviews(false)}
          />
        ) : null}
      </div>
    );
};

export default Profile;